module.exports = __webpack_public_path__ + "media/images/lb/378-13c57eadfd0944d12b0e32f379122082.svg";